module.exports = __webpack_public_path__ + "assets/icon-reviews-component.0bcfbebb.svg";